import React from 'react';
import { View } from 'react-native';

function GridItem({ item, isRightGapNeeded, index, gap, width, renderItem }) {
  return (
    <View key={item.id} style={{ width, marginBottom: gap, paddingRight: !isRightGapNeeded ? 0 : gap }}>
      {renderItem({ item, index })}
    </View>
  );
}
export default GridItem;
